import { render, staticRenderFns } from "./CierreElRoble.vue?vue&type=template&id=fc865fd4&"
import script from "./CierreElRoble.vue?vue&type=script&lang=js&"
export * from "./CierreElRoble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports